import { TreeItemType } from "../models/TreeItemType";
import { ChildLoadState } from "../models/ChildLoadState";
export var isParentTreeItemType = function (treeItemType) {
    switch (treeItemType) {
        case TreeItemType.FOLDER:
        case TreeItemType.WORKSPACE:
        case TreeItemType.FAVORITE:
        case TreeItemType.COLLECTIONS:
        case TreeItemType.CONTENT:
        case TreeItemType.CONTENT_LIBRARY:
            return true;
        default:
            return false;
    }
};
export var assertUnreachable = function (x) {
    throw new Error("Should never be able to reach this");
};
export function hasChildren(childData) {
    return childData != null;
}
export function isChildrenLoaded(childData) {
    return Boolean(childData && childData.loadState === ChildLoadState.loaded);
}
export function isChildrenNotLoaded(childData) {
    return Boolean(childData && childData.loadState === ChildLoadState.not);
}
export var isLoading = function (childData) {
    return Boolean(childData && childData.loadState === ChildLoadState.loading);
};
export var isFailed = function (childData) {
    return Boolean(childData && childData.loadState === ChildLoadState.failed);
};
export var containerTreeSort = function (a, b) {
    if (a.isPersonalWorkspace) {
        return -1;
    }
    if (b.isPersonalWorkspace) {
        return 1;
    }
    if (a.containerType === TreeItemType.FOLDER &&
        b.containerType === TreeItemType.FOLDER) {
        return a.name.localeCompare(b.name);
    }
    if (a.containerType === TreeItemType.FOLDER) {
        return 1;
    }
    if (b.containerType === TreeItemType.FOLDER) {
        return -1;
    }
    return a.name.localeCompare(b.name);
};
export var isFolder = function (data) {
    return data.containerType === TreeItemType.FOLDER;
};
export var getOrderedItems = function (tree, expandedSet, nodes, level) {
    if (nodes === void 0) { nodes = []; }
    if (level === void 0) { level = 0; }
    for (var i = 0; i < tree.length; i++) {
        var node = tree[i];
        node.level = level;
        node.sizeOfSet = tree.length;
        node.positionInSet = i + 1;
        nodes.push(node);
        if (expandedSet.has(node) && isChildrenLoaded(node.childData)) {
            getOrderedItems(node.childData.childrenData, expandedSet, nodes, level + 1);
        }
    }
    return nodes;
};
export var getOrderedItemIndex = function (item, items) {
    return items.findIndex(function (arrayItem) {
        return (arrayItem.id === item.id &&
            arrayItem.containerType === item.containerType);
    });
};
export var getFirstItemToSetFocus = function (orderedItems, selectedSet, initialFocusItem) {
    var itemIndex = -1;
    if (initialFocusItem) {
        itemIndex = getOrderedItemIndex(initialFocusItem, orderedItems);
    }
    else if (selectedSet.size() > 0) {
        // initialFocusItem is undefined so we can't set focus to that, but we can try and set it to the first item in selectedSet.
        selectedSet.forEach(function (value, key) {
            if (itemIndex !== -1) {
                return;
            }
            itemIndex = getOrderedItemIndex(value, orderedItems);
        });
    }
    if (itemIndex !== -1) {
        return itemIndex;
    }
    else {
        return 0;
    }
};
//# sourceMappingURL=ContainerUtil.js.map